import React, { useEffect, useState } from 'react';
import {
  Box, SimpleGrid, Stat, StatLabel, StatNumber,
  Text, Flex, Card, CardBody, Spinner
} from '@chakra-ui/react';
import {
  PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend
} from 'recharts';

const DashboardMultaObstruccion = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/multa-obstruccion`)
      .then(res => res.json())
      .then(json => {
        setData(json);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, []);

  const total = data.length;
  const conRetiro = data.filter(d => d.retiro === true).length;
  const sinRetiro = data.filter(d => d.retiro === false).length;
  const totalCosto = data.reduce((acc, curr) => acc + Number(curr.costo || 0), 0);

  const chartData = [
    { name: 'Con retiro', value: conRetiro },
    { name: 'Sin retiro', value: sinRetiro }
  ];

  const colors = ['#E53E3E', '#3182CE'];

  if (isLoading) {
    return (
      <Box p={6}>
        <Spinner />
      </Box>
    );
  }

  return (
    <Box p={6}>
      <Flex justify="center" mb={6}>
 

        <Card flexBasis={{ base: '100%', md: '400px' }} boxShadow="none">
          <CardBody>
            <Text fontWeight="bold" mb={4} textAlign="center">
              Distribución por Retiro
            </Text>
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={chartData}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  label
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </CardBody>
        </Card>
      </Flex>

      <SimpleGrid columns={{ base: 4, md: 4 }} spacing={4} flex={1}>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Total Multas</StatLabel>
            <StatNumber>{total}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Con Retiro</StatLabel>
            <StatNumber>{conRetiro}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Sin Retiro</StatLabel>
            <StatNumber>{sinRetiro}</StatNumber>
          </Stat>
          <Stat p={4} bg="white" borderRadius="md" boxShadow="md">
            <StatLabel>Total Recaudado</StatLabel>
            <StatNumber>${totalCosto.toFixed(2)}</StatNumber>
          </Stat>
        </SimpleGrid>
    </Box>
  );
};

export default DashboardMultaObstruccion;
